import compact from 'lodash-es/compact'
import get from 'lodash-es/get'
import * as React from 'react'

import { marketSearchApi } from '@envato/foundation-types'

import Tooltip from '../../tooltip'

import * as styles from './lockupAudioTrackInfo.module.css'

const isItemPack = (classification: string): boolean =>
  classification.startsWith('music-packs') ||
  classification.startsWith('logos-idents/packs')

const getMainTrackLength = (attributes: marketSearchApi.IAttribute[]) =>
  get(
    attributes.filter(
      ({ name }: marketSearchApi.IAttribute) => name === 'length-audio'
    ),
    '[0].value',
    ''
  )

const getAdditionalTrackLengthsString = (
  attributes: marketSearchApi.IAttribute[]
) =>
  get(
    attributes.filter(
      ({ name }: marketSearchApi.IAttribute) =>
        name === 'length-audio-additional'
    ),
    '[0].value',
    ''
  ) || ''

const getTracksCount = (attributes: marketSearchApi.IAttribute[]) => {
  const mainTrackLength = getMainTrackLength(attributes)
  const additionalTrackLengthsString = getAdditionalTrackLengthsString(
    attributes
  )
  const additionalTrackLengthsArray = compact(
    additionalTrackLengthsString.split(',')
  )
  const tracksNumber = additionalTrackLengthsArray.length + 1
  const tracksLengthsArray = compact([
    mainTrackLength,
    ...additionalTrackLengthsArray
  ])
  const tracksLengths = tracksLengthsArray.join(', ')

  return (
    <span className={styles.tracksArea}>
      Tracks{' '}
      {tracksLengthsArray.length > 1 ? (
        <Tooltip
          title={
            <span>
              <b>Tracks length:</b> {tracksLengths}
            </span>
          }
        >
          <span className={`${styles.bold} ${styles.dottedUnderline}`}>
            {tracksNumber}
          </span>
        </Tooltip>
      ) : (
        <span className={styles.bold}>{tracksNumber}</span>
      )}
    </span>
  )
}

const getPackInfo = () => (
  <span className={styles.tracksArea}>
    <Tooltip
      title={
        <span>
          <b>Contains multiple tracks</b>
        </span>
      }
    >
      <span className={`${styles.dottedUnderline}`}>Pack</span>
    </Tooltip>
  </span>
)

const TracksData = ({
  attributes,
  classification
}: {
  attributes: marketSearchApi.IAttribute[]
  classification: string
}) => {
  if (isItemPack(classification)) {
    return getPackInfo()
  } else {
    return getTracksCount(attributes)
  }
}

export default TracksData
